export const clamp = (num: number, min: number, max: number): number => Math.min(Math.max(num, min), max)
export const interpolate = (value: number, min: number, max: number): number => min + clamp(value, 0, 1) * (max - min)
